<template>
  <div>
    <LoginLogs></LoginLogs>
  </div>
</template>

<script>
const LoginLogs = defineAsyncComponent(() =>
  import("@/components/logs/UserLoginLogs")
);
import { defineAsyncComponent } from "vue";
export default {
  components: {
    LoginLogs,
  },
};
</script>
